<template>
  <div class="goods-manage-box" v-loading="loading > 0" :element-loading-text="loadingText">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="btn-box">
            <div class="label">是否热门产品：</div>
            <el-select
              v-model="filter.isHot"
              size="small"
              class="select"
              style="width: 153px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option :value="1" label="是"> </el-option>
              <el-option :value="0" label="否"> </el-option>
            </el-select>
            <div class="label">品牌：</div>
            <el-select
              v-model="filter.brand"
              size="small"
              class="select"
              style="width: 153px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option
                :value="item.id"
                :label="item.brandName"
                v-for="item in brandList"
                :key="item.id"
              >
              </el-option>
            </el-select>
            <div class="label">状态：</div>
            <el-select
              v-model="filter.status"
              size="small"
              class="select"
              style="width: 153px"
              placeholder="请选择"
            >
              <el-option :value="null" label="全部"> </el-option>
              <el-option :value="3" label="上架中"> </el-option>
              <el-option :value="1" label="隐藏"> </el-option>
            </el-select>
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 188px; margin-left: 40px"
              placeholder="此框输入产品名搜索"
              size="small"
            ></el-input>
            <button class="search" @click="search">搜索</button>
            <button class="reset" @click="reset">重置</button>
          </div>
          <div style="display:flex;gap:12px"><div class="btn" @click="$router.push({name:'aiProductSettings'})">AI推荐配置</div><div class="btn" @click="toGood('add')">+ 添加产品</div></div>
        </div>
        <div class="filter-box">
          <div class="btn-box">
            <button class="reset" style="width: 80px;position: relative;">
              导入
              <input
                type="file"
                style="width: 100%;height: 100%;opacity: 0;position: absolute;top: 0;left: 0;"
                ref="import"
                id="impExcel"
                @change="handleImport"
                accept="*.xls"
              />
            </button>
            <button
              class="search"
              style="width: 80px;margin-left: 20px;"
              @click="handleExportModal"
            >
              导出
            </button>
            <button
              class="reset"
              style="width: 120px;margin-left: 20px;"
              @click="updateAIproducts"
            >
              更新AI产品库
            </button>
          </div>
        </div>
        <el-table
          :data="goodsList"
          class="table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="master_pic" align="center" label="产品主图">
            <div slot-scope="scope">
              <el-image
                class="master-pic"
                :src="scope.row.masterPic"
                :preview-src-list="[scope.row.masterPic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="产品ID"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="参考价格/元"
          ></el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ scope.row.status === 3 ? "上架中" : "隐藏" }}
            </div>
          </el-table-column>
          <el-table-column prop="brandName" align="center" label="品牌">
          </el-table-column>
          <el-table-column prop="twig" align="center" label="排序">
            <template slot-scope="scope">
              <u class="blue" @click="editSort(scope.row)">{{
                scope.row.twig
              }}</u>
            </template>
          </el-table-column>
          <el-table-column prop="hot" align="center" label="是否选为热门">
            <div
              slot-scope="scope"
              @click="changeGoodHot(scope.row.id, scope.row.isHot)"
            >
              <i
                v-if="scope.row.isHot === 1"
                class="iconfont icon-xuanzye checked-icon"
                style="color: #6B95FF;"
              ></i>
              <i v-else class="iconfont icon-weixzye"></i>
              {{ scope.row.isHot === 1 ? "是" : "否" }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="560">
            <div slot-scope="scope">
              <div class="table-btn-box">
                <button
                  size="mini"
                  class="table-btn"
                  style="width: 85px;min-width: 85px;"
                  @click="toGood('edit', scope.row.id)"
                >
                  编辑基础信息
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toGoodLabel(scope.row.id)"
                >
                  编辑标签
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toGoodComponent(scope.row.id)"
                >
                  编辑成分
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toGoodParams(scope.row.id)"
                >
                  参数设置
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-if="scope.row.status === 3"
                  @click="updateStatus(1, scope.row.id)"
                >
                  下架
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  v-else
                  @click="updateStatus(3, scope.row.id)"
                >
                  上架
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteGood(scope.row.id)"
                >
                  删除
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="copyGood(scope.row.id)"
                >
                  复制
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="是否用于AI训练"
      width="400px"
      :visible.sync="forTrainShow"
    >
      <el-form size="mini" ref="editSort" inline-message>
        <el-form-item
          label="是否用于ai训练"
          prop="tableData"
          style="margin-top: 15px"
        >
          <el-switch
            v-model="forTrain"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="forTrainShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="handleExport"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import { baseUrl } from '@/config';
export default {
  components: {
    Header
  },
  name: 'goods-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      loadingText: '',
      title: {
        // 页面标题
        firstTitile: '产品管理',
        secondTitle: '产品管理'
      },
      filter: {
        isHot: null,
        brand: null,
        status: null,
        name: '',
      },
      goodsList: [], // 列表
      currentId: null,
      currentSort: null,
      sortShow: false,
      paginationKey: +new Date(),
      showProgressDialog: false,
      progress: 0,
      brandList: [],
      forTrainShow: false,
      forTrain: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'good' && from.name !== 'goodComponent' && from.name !== 'goodLabel') {
      sessionStorage.setItem('goodManage', '');
    }
    next();
  },
  mounted() {
    let data = sessionStorage.getItem('goodManage')
      ? JSON.parse(sessionStorage.getItem('goodManage'))
      : '';
      console.log(data);
    if (data) {
      this.filter = {
        ...this.filter,
        ...data.filter
      };
      this.currentPage = data.currentPage;
      // this.category = data.category || []
      this.paginationKey = +new Date();
      this.setSearchData();
    }
    // 获取列表
    this.getBrandList();
    this.getGoodsList();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    setSearchData() {
      let goodManage = {
        currentPage: this.currentPage,
        filter: this.filter,
        // category: this.category || []
      };
      sessionStorage.setItem('goodManage', JSON.stringify(goodManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getGoodsList();
    },
    // 获取产品列表
    getGoodsList() {
      this.setSearchData();
      this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.goodsList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {
        size: 9999
      }).then(
        (res) => {
          this.loading--;
          this.brandList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getGoodsList();
    },
    reset(){
      this.filter = {
        isHot: null,
        brand: null,
        status: null,
        name: '',
      };
      this.currentPage = 1;
      this.getGoodsList();
    },
    changeGoodHot(id, isHot) {
      let str = '';
      if(isHot === 1){
        str = '取消';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}设置该产品为热门产品？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.setHotGood, {
          id,
          isHot: isHot === 1 ? 0 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    editSort(rowData) {
      // 更改排序
      this.currentId = rowData.id;
      this.sortShow = true;
      this.currentSort = rowData.twig;
    },
    saveSort() {
      // 保存排序
      this.loading++;
      this.httpPut(this.$root.updateGoodTwig, {
        id: +this.currentId,
        twig: +this.currentSort
      }).then(
        (res) => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.getGoodsList();
          this.loading--;
          this.sortShow = false;
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    },
    updateStatus(status, id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要将产品${
          status === 1 ? '放入仓库' : '上架'
        }吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.updateGoodStatus, {
          id,
          status
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除产品
    deleteGood(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除产品吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteGood, {
          id
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    copyGood(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要复制产品吗</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.copyGood, {
          id
        }).then(
          (res) => {
            this.loading--;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getGoodsList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 添加/编辑产品
    toGood(type, id) {
      this.$router.push({
        name: 'good',
        query: {
          type,
          id
        }
      });
    },
    toGoodLabel(id) {
      this.$router.push({
        name: 'goodLabel',
        query: {
          id
        }
      });
    },
    toGoodComponent(id) {
      this.$router.push({
        name: 'goodComponent',
        query: {
          id
        }
      });
    },
    toGoodParams(id) {
      this.$router.push({
        name: 'paramsSetting',
        query: {
          id
        }
      });
    },
    async order2excel() {
      // if(!(await this.exportLog())) return;
      this.loading++;
      let goodsList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      };
      await this.httpGet(this.$root.getGoodsList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, goodsList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(goodsList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter,
        };
        await this.httpGet(this.$root.getGoodsImportList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    getAttrs(attrs) {
      return attrs
        .map((item) => {
          return item.keyName + '：' + item.value;
        })
        .join('; ');
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        item.skuList.forEach((sku, skuIndex) => {
          let obj = {};
          if(skuIndex === 0){
            obj = {
              ID: item.spu.id,
              产品名称: item.spu.name,
              // 产品主图: item.masterPic,
              关联分类: item.firstSortName,
              关联品牌: item.brandName,
              // '价格/元': item.minPrice,
              产品状态: item.spu.status === 3 ? "出售中" : "仓库中",
              规格编码: sku.code,
              规格名称: this.getAttrs(sku.attrs),
              普通会员价: +sku.price,
              库存: +sku.stock,
              划线价: +item.spu.linePrice,
              产品排序: item.spu.twig,
              创建时间: item.spu.created,
              更新时间: item.spu.updated,
              核算比例: item.spu.accountingRate
            }
          } else {
            obj = {
              // ID: '',
              // 产品名称: '',
              // 产品主图: '',
              // 关联分类: '',
              // 关联品牌: '',
              // '价格/元': item.minPrice,
              // 产品状态: '',
              规格编码: sku.code,
              规格名称: this.getAttrs(sku.attrs),
              普通会员价: sku.price,
              库存: sku.stock,
              // 划线价: null,
              // 产品排序: '',
              // 创建时间: '',
              // 更新时间: '',
              // 核算比例: ''
            }
          }
          // item.skuList.forEach((sku, index) => {
          //   obj[`规格${index + 1}`] = this.getAttrs(sku.attrs);
          //   obj[`规格${index + 1} 价格`] = sku.price;
          //   obj[`规格${index + 1} 库存`] = sku.stock;
          //   obj[`规格${index + 1} 编码`] = sku.code;
          // });
          formatList.push(obj);
        })
      });
      // console.log(formatList);
      myUtils.json2excel(formatList);
    },
    handleImport(e){
      let file = e.target.files[0];
      this.loading++;
      this.httpUploadFile(
        this.$root.uploadExcel,
        {
          file: file
        },
        { 'Content-Type': 'multipart/form-data' }
      ).then(
        (res) => {
          this.loading--;
          this.$refs.import.value = '';
          this.$message.success('导入成功！');
          this.getGoodsList();
        },
        (err) => {
          this.loading--;
          this.$refs.import.value = '';
          this.$message.error(err);
        }
      );
    },
    handleExportModal(){
      this.forTrain = 0;
      this.forTrainShow = true;
    },
    handleExport(){
      this.loading++;
      let filter = {};
      for(let key in this.filter){
        filter[key] = this.filter[key] ? (this.filter[key] + '') : '';
      }
      this.httpPost(this.$root.exportGoods, {
        forTrain: this.forTrain,
        ...filter,
      }).then(
        (res) => {
          this.loading--;
          this.forTrainShow = false;
          // console.log();
          const url = baseUrl + res.fileName;
          // console.log(url, 'url')
          const a = document.createElement('a');
          a.href = url;
          a.download = '产品成分.xlsx'; // 自定义文件名
          document.body.appendChild(a);
          a.click();
          a.remove();
          // window.URL.revokeObjectURL(url);
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    updateAIproducts(){
      this.loadingText = '正在更新中';
      this.loading++;
      this.httpPost(this.$root.updateDiagnosticProduct, {}).then(
        (res) => {
          this.loading--;
          this.$message.success('更新成功！');
          this.loadingText = '';
        },
        (err) => {
          this.loading--;
          this.$message.error(err);
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.goods-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    .blue {
      color: btn-color;
      cursor: pointer;
    }

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box {
        flex-wrap: wrap;

        .btn-box {
          margin: 5px 0;
          flex-x(flex-start);
          flex-wrap: wrap;

          .label {
            margin-right: 6px;
            margin-left: 12px;
            word(14px, gray3);
          }

          .input {
            margin-right: 8px;
          }

          .search {
            min-width: 65px;
          }
        }
      }

      .import-box {
        width: 100%;
        flex-x(flex-end);
      }

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
        flex-shrink: 0;
      }

      .table {
        .master-pic {
          width: auto;
          height: 32px;
        }
      }

      .vip-btn {
        width: 96px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #E8E8E8;
        background: #F7F7F7;
        word(12px, btn-color);
        flex-x(center);
        white-space: nowrap;
        margin: 0 5px;
        cursor: pointer;
      }

      .table-btn-box {
        flex-x(flex-end);

        .table-btn {
          width: 65px;
          min-width: 65px;
          height: 24px;
          line-height: 24px;
          color: gray3;
          font-size: 12px;
          margin-right: 8px;
          cancel-btn();
        }
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .wx-category-box{
    flex-x();
    padding: 5px 0;
    background: #F7F7F7;
    .step{
      flex: 1;
      height: 320px;
      border-right: 1px solid #D8D8D8;
      background: #F7F7F7;
      padding: 0 10px;
      box-sizing: border-box;
      overflow-y: auto;
      .item{
        height: 36px;
        flex-x();
        padding: 0 12px;
        box-sizing: border-box;
        border-radius: 5px;
        &:hover{
          background: #F8E8E5;
        }
        &.active{
          background: #F8E8E5;
        }
      }
      &:nth-of-type(1){
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:nth-of-type(3){
        border-right: none;
      }
    }
  }
  .wx-category-box2{
    padding: 0 24px;
    box-sizing: border-box;
    .list{
      margin-top: 36px;
    }
    .item{
      margin: 6px 0;
      flex-x(flex-start);
      .label{
        width: 65px;
      }
      .input1{
        width: 160px;
      }
      .input2{
        width: 200px;
        margin-left: 12px;
      }
    }
  }
}
</style>
